// In production, we'll use a relative URL for the API
const getBaseUrl = () => {
  // For development environment, use the full URL
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api/v1';
  }
  
  // For production environment, use a relative URL
  return '/api/v1';
};

export const API_CONFIG = {
  baseURL: getBaseUrl(),
  timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const ENDPOINTS = {
  // Auth
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    me: '/auth/me',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    changePassword: '/auth/change-password',
  },
  
  // Users
  users: {
    list: '/users',
    detail: (id: string) => `/users/${id}`,
    create: '/users',
    update: (id: string) => `/users/${id}`,
    delete: (id: string) => `/users/${id}`,
  },
  
  // Leaves
  leaves: {
    list: '/leaves',
    detail: (id: string) => `/leaves/${id}`,
    create: '/leaves',
    update: (id: string) => `/leaves/${id}`,
    delete: (id: string) => `/leaves/${id}`,
    approve: (id: string) => `/leaves/${id}/approve`,
    reject: (id: string) => `/leaves/${id}/reject`,
    types: '/leaves/types',
    balances: '/leaves/balances',
  },
  
  // Teams
  teams: {
    list: '/teams',
    detail: (id: string) => `/teams/${id}`,
    create: '/teams',
    update: (id: string) => `/teams/${id}`,
    delete: (id: string) => `/teams/${id}`,
  },
  
  // Departments
  departments: {
    list: '/departments',
    detail: (id: string) => `/departments/${id}`,
    create: '/departments',
    update: (id: string) => `/departments/${id}`,
    delete: (id: string) => `/departments/${id}`,
  },
  
  // Reports
  reports: {
    leaves: '/reports/leaves',
    balances: '/reports/balances',
    usage: '/reports/usage',
  },
  
  // Substitutions
  substitutions: {
    my: '/substitutions/my',
    history: '/substitutions/history',
    respond: (id: string) => `/substitutions/${id}/respond`,
  },
  
  // Notifications
  notifications: {
    list: '/notifications',
    markRead: (id: string) => `/notifications/${id}/read`,
    markAllRead: '/notifications/read-all',
  },
} as const;